import { render, staticRenderFns } from "./ModifyArtical.vue?vue&type=template&id=7d8ac4e4&scoped=true&"
import script from "./ModifyArtical.vue?vue&type=script&lang=js&"
export * from "./ModifyArtical.vue?vue&type=script&lang=js&"
import style0 from "./ModifyArtical.vue?vue&type=style&index=0&id=7d8ac4e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8ac4e4",
  null
  
)

export default component.exports